import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Download24 } from '@carbon/icons-react';
import Image from '../../image';

class ParagraphDownload extends Component {
  render() {
    const sectionClassNames = classNames({
      'paragraph paragraph-download': true
    });

    return (
      <section className={sectionClassNames}>

        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="row">
                <a className="d-flex col-lg-12 download" href={this.props.content.fieldDatei.entity.fieldMediaFile.entity.url} download={true}>
                  <h3>{this.props.content.fieldDatei.entity.entityLabel}</h3>
                  <img src="/themes/custom/module_box/src/images/Formular-Download.svg" alt=""/>
                </a>
              </div>
            </div>
          </div>
        </div>

      </section>
    );
  }
}

ParagraphDownload.propTypes = {
  content: PropTypes.object.isRequired
};

export default ParagraphDownload;
